export const TOURNAMENT_LIST_TABLE_HEADERS = [
  'Nombre',
  'Tipo',
  'Género',
  'Modalidad',
  'Categoria',
  'Número de rondas',
  'Pintas',
  'Final incluída',
  'Estado',
  'Inscritos',
  'Acción',
];
export const NATIONAL_RANKING_HEADERS = [
  'Posición',
  'Nombre Completo',
  'Torneo',
  'Torneo',
  'Torneo',
  'Torneo',
  'Torneo',
  'Acciones',
  'Puntaje',
];

export const PLAYERS_HEADERS = [
  'Nombre',
  'Ciudad',
  'Genero',
  'Estado',
  'Club',
  'Acciónes',
];

export const ADMIN_HEADERS = ['Nombre', 'Teléfono', 'Correo', 'Acciones'];
export const GROUP_HEADERS = ['Grupo', 'Integrantes', 'Acciones'];
export const CLUB_HEADERS = ['Nombre', 'Direccion', 'Acciones'];

export const TABS_INDIVIDUAL_MODE = [
  'Participantes',
  'Rondas',
  'Clasificación',
  'Configuraciones',
];

export const TABS_TEAM_MODE = [
  'Participantes',
  'Grupos formados',
  'Rondas',
  'Clasificación',
  'Configuraciones',
];

export const ROUND_HEADERS = [
  '# Mesa',
  'Jugadores A',
  'Puntos',
  'Jugadores B',
  'Puntos',
  'Acciones',
];

export const STANDING_HEADERS = [
  'Posición',
  '# Grupo',
  'Atletas',
  'PJ',
  'PG',
  'PP',
  'DP',
  'EFF',
  'P.Favor',
  'P.Contra',
  'Diff',
];

export const PLAYER_LIST = [
  'Correo',
  'Nombre',
  'Teléfono',
  'Género',
  'Dirección',
  'Club',
  'Estado Registro',
  'Documento',
];
